<div class="tara-login">
	<!-- Soft background wash -->
	<div class="tara-login__wash" aria-hidden="true"></div>

	<!-- Grid -->
	<div class="tara-login__grid" aria-hidden="true"></div>

	<!-- Artificial horizon -->
	<div class="tara-login__horizon" aria-hidden="true"></div>
	<div class="tara-login__horizon-ticks" aria-hidden="true">
		@for (tick of horizonTicks; track tick) {
			<span class="tara-login__horizon-tick" [class.tara-login__horizon-tick--tall]="tick % 2 === 0"></span>
		}
	</div>

	<!-- Trajectory + radar arcs -->
	<svg class="tara-login__trajectories" viewBox="0 0 1600 1000" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
		<defs>
			<linearGradient id="tara-traj" x1="0%" y1="0%" x2="100%" y2="100%">
				<stop offset="0%" stop-color="#E94335" stop-opacity="0" />
				<stop offset="50%" stop-color="#E94335" stop-opacity="0.7" />
				<stop offset="100%" stop-color="#E94335" stop-opacity="0" />
			</linearGradient>
			<linearGradient id="tara-traj2" x1="0%" y1="100%" x2="100%" y2="0%">
				<stop offset="0%" stop-color="#E94335" stop-opacity="0" />
				<stop offset="50%" stop-color="#ff6b5d" stop-opacity="0.35" />
				<stop offset="100%" stop-color="#E94335" stop-opacity="0" />
			</linearGradient>
		</defs>

		<path
			class="tara-login__traj tara-login__traj--1"
			d="M -100 700 Q 400 200 900 450 T 1700 250"
			stroke="url(#tara-traj)"
			stroke-width="1.5"
			fill="none"
		/>
		<path
			class="tara-login__traj tara-login__traj--2"
			d="M -100 850 Q 600 600 1100 720 T 1700 500"
			stroke="url(#tara-traj2)"
			stroke-width="1"
			fill="none"
		/>
		<path
			class="tara-login__traj tara-login__traj--3"
			d="M 0 100 Q 500 400 1000 150 T 1700 300"
			stroke="url(#tara-traj)"
			stroke-width="0.8"
			stroke-dasharray="4 8"
			fill="none"
		/>

		<circle class="tara-login__radar-arc tara-login__radar-arc--1" cx="1400" cy="200" r="120" />
		<circle class="tara-login__radar-arc tara-login__radar-arc--2" cx="200" cy="800" r="80" />
	</svg>

	<!-- HUD corner brackets -->
	<div class="tara-login__bracket tara-login__bracket--tl" aria-hidden="true"></div>
	<div class="tara-login__bracket tara-login__bracket--tr" aria-hidden="true"></div>
	<div class="tara-login__bracket tara-login__bracket--bl" aria-hidden="true"></div>
	<div class="tara-login__bracket tara-login__bracket--br" aria-hidden="true"></div>

	<!-- HUD readouts -->
	<div class="tara-login__readout-top" aria-hidden="true">
		<span>HDG 087</span>
		<span class="tara-login__sys">● SYS NOMINAL</span>
		<span>ALT 34,000 FT</span>
	</div>
	<div class="tara-login__readout-bottom" aria-hidden="true">
		<span class="tara-login__readout-bottom-full">AirAsia Flight Operations · Secure Terminal</span>
		<span class="tara-login__readout-bottom-short">AirAsia Flight Ops</span>
	</div>

	<!-- Speed tape -->
	<div class="tara-login__tape tara-login__tape--speed" aria-hidden="true">
		<div class="tara-login__tape-label">KIAS</div>
		<div class="tara-login__tape-frame">
			<div class="tara-login__tape-scroll tara-login__tape-scroll--speed">
				@for (v of speedTapeValues; track v) {
					<div class="tara-login__tape-row tara-login__tape-row--end">
						<span>{{ v }}</span>
						<span class="tara-login__tape-mark"></span>
					</div>
				}
			</div>
			<div class="tara-login__tape-cursor tara-login__tape-cursor--speed">
				<span>312</span>
			</div>
		</div>
	</div>

	<!-- Altitude tape -->
	<div class="tara-login__tape tara-login__tape--alt" aria-hidden="true">
		<div class="tara-login__tape-label">ALT FT</div>
		<div class="tara-login__tape-frame tara-login__tape-frame--wide">
			<div class="tara-login__tape-scroll tara-login__tape-scroll--alt">
				@for (v of altitudeTapeValues; track v) {
					<div class="tara-login__tape-row tara-login__tape-row--start">
						<span class="tara-login__tape-mark"></span>
						<span>{{ v }}</span>
					</div>
				}
			</div>
			<div class="tara-login__tape-cursor tara-login__tape-cursor--alt">
				<span>34,000</span>
			</div>
		</div>
	</div>

	<!-- Compass rose -->
	<div class="tara-login__compass" aria-hidden="true">
		<svg viewBox="0 0 100 100" class="tara-login__compass-dial">
			<circle cx="50" cy="50" r="46" fill="none" stroke="rgba(15,23,42,0.2)" stroke-width="0.5" />
			<circle cx="50" cy="50" r="40" fill="none" stroke="rgba(15,23,42,0.15)" stroke-width="0.3" />
			@for (i of compassTicks; track i) {
				<line
					x1="50"
					y1="4"
					x2="50"
					[attr.y2]="i % 3 === 0 ? 10 : 7"
					stroke="rgba(15,23,42,0.35)"
					stroke-width="0.4"
					[attr.transform]="'rotate(' + i * 10 + ' 50 50)'"
				/>
			}
			@for (d of compassDirs; track d; let i = $index) {
				<text
					x="50"
					y="20"
					text-anchor="middle"
					font-size="6"
					[attr.fill]="d === 'N' ? '#E94335' : 'rgba(15,23,42,0.6)'"
					font-weight="700"
					[attr.transform]="'rotate(' + i * 90 + ' 50 50)'"
				>
					{{ d }}
				</text>
			}
		</svg>
		<div class="tara-login__compass-center"></div>
		<div class="tara-login__compass-needle"></div>
	</div>

	<!-- Radar sweep -->
	<div class="tara-login__radar" aria-hidden="true">
		<div class="tara-login__radar-ring tara-login__radar-ring--outer">
			<div class="tara-login__radar-ring tara-login__radar-ring--mid"></div>
			<div class="tara-login__radar-ring tara-login__radar-ring--inner"></div>
			<div class="tara-login__radar-cross-v"></div>
			<div class="tara-login__radar-cross-h"></div>
			<div class="tara-login__radar-sweep"></div>
			<div class="tara-login__radar-blip tara-login__radar-blip--1"></div>
			<div class="tara-login__radar-blip tara-login__radar-blip--2"></div>
		</div>
		<div class="tara-login__radar-label">Radar · 50nm</div>
	</div>

	<!-- Data stream -->
	<div class="tara-login__datastream" aria-hidden="true">
		@for (line of dataStreamLines; track line; let i = $index) {
			<span class="tara-login__datastream-line" [style.animation-delay]="0.3 + i * 0.4 + 's'">
				{{ line }}
			</span>
		}
		<span class="tara-login__datastream-cursor">› █</span>
	</div>

	<!-- Vignette -->
	<div class="tara-login__vignette" aria-hidden="true"></div>

	<!-- Login card -->
	<div class="tara-login__card-wrap">
		<div class="tara-login__card-glow" aria-hidden="true"></div>
		<div class="tara-login__card">
			@for (light of borderLights; track $index) {
				<span
					class="tara-login__border-light"
					[class.tara-login__border-light--left]="light.side === 'left'"
					[class.tara-login__border-light--right]="light.side === 'right'"
					[style.top]="light.top"
					[style.background]="light.color"
					[style.box-shadow]="'0 0 10px ' + light.color + ', 0 0 20px ' + light.color + '80'"
					[style.animation-delay]="light.delay"
					aria-hidden="true"
				></span>
			}

			<div class="tara-login__card-sheen" aria-hidden="true"></div>
			<div class="tara-login__scanline" aria-hidden="true"></div>

			<div class="tara-login__card-body">
				<div class="tara-login__logo" aria-hidden="true">
					<svg class="tara-login__logo-disc" viewBox="0 0 200 200" fill="none">
						<path
							d="M200 100.043C200 155.28 155.28 200 100.043 200C44.8055 200 0 155.195 0 100.043C0 44.8055 44.72 0 100.043 0C155.195 0 200 44.8055 200 100.043Z"
							fill="#E94335"
						/>
					</svg>
					<svg class="tara-login__logo-mark" viewBox="0 0 165.714 70.5882" fill="none">
						<path
							d="M55.2763 16.2844C57.4322 15.8582 59.0905 17.2221 58.9247 19.268C58.7588 21.3139 56.8518 23.3597 54.6959 23.7859C52.5401 24.2122 50.8818 22.8482 51.0476 20.7171C51.2134 18.6713 53.0376 16.7107 55.2763 16.2844ZM31.8938 31.117C33.8009 23.9564 36.0397 16.5402 38.2784 11.0845C33.718 17.2221 28.9088 24.9794 24.5143 32.7366C27.0018 32.0547 29.4893 31.5432 31.8938 31.117ZM70.533 25.4908C72.1913 25.1499 76.0055 27.5367 74.1813 29.7531C72.2743 31.9694 70.1184 31.5432 66.8018 32.9923C64.8947 33.8448 63.4851 35.5497 61.4122 38.6185C58.7588 42.625 57.598 46.5462 57.3493 49.4446C57.3493 50.297 57.2663 50.7232 56.8518 51.0642C52.4572 54.0478 51.0476 51.8314 51.1305 49.1036C51.1305 48.4216 51.3793 47.3987 51.7938 46.2053C48.3943 51.4904 45.3263 54.133 43.4193 54.474C40.7659 54.9854 39.2734 53.1101 39.5222 49.615C39.688 47.9954 40.1026 46.2053 41.0147 43.8184C41.9268 41.4316 43.3363 38.1923 44.663 35.4645C44.9947 34.7825 45.3263 34.1005 45.5751 33.5038C43.5851 33.93 40.683 34.5268 37.3663 35.294C37.3663 35.3792 37.2834 35.4645 37.2834 35.4645C35.8738 42.284 35.708 44.9266 34.9618 50.8085C34.6301 53.4511 35.1276 56.2641 32.1426 56.6903C29.1576 57.1166 28.1626 53.9625 28.0797 51.1495C28.0797 48.4216 28.5772 45.0118 30.4843 36.9136C27.3334 37.766 24.0168 38.7038 20.7001 39.7267C20.6172 39.8119 20.6172 39.8119 20.6172 39.8119C15.1447 50.0413 9.7551 62.7427 8.92593 66.8344C8.17968 70.159 6.77009 71.0967 4.61426 70.159C2.45843 69.2213 1.2976 67.0049 2.04385 64.5328C3.45343 60.1001 7.68218 50.2118 11.4963 43.1365C11.4963 43.1365 11.4963 43.0512 11.5793 42.8807C8.84301 43.9889 6.18968 45.1823 3.95093 46.461C2.45843 47.3134 0.551347 46.5463 0.21968 44.8414C-0.0290695 43.6479 -0.609483 41.2611 2.2926 39.8972C6.68718 37.9365 11.4134 36.2316 16.0568 34.8677C26.0897 17.5631 38.5272 -0.253013 42.0926 0.00272077C43.668 0.17321 43.4193 1.8781 44.7459 3.4125C46.0726 4.9469 46.3213 5.88458 44.663 10.0616C41.3463 18.5008 41.5951 16.5402 38.4443 29.7531C44.2484 28.7301 49.3063 28.2187 49.8038 28.1334C51.3793 27.8777 54.1984 29.0711 52.7059 32.2252C52.7059 32.2252 51.1305 35.0382 50.5501 36.2317C49.4722 38.1923 48.0626 41.1758 47.1505 43.1365C46.5701 44.3299 46.3213 45.1823 46.3213 45.8643C46.3213 46.2905 46.4043 46.5462 46.7359 46.461C47.2334 46.3758 47.8138 45.8643 48.643 45.0118C49.3893 44.0741 51.9597 41.8578 56.603 33.8448L57.8468 31.2875C58.2613 30.5203 58.7588 29.1564 58.9247 28.5596C59.0076 27.622 59.0905 27.3662 59.8367 26.8548C61.0805 26.0876 63.2363 25.4056 64.563 26.258C65.7238 27.1105 65.4751 28.5596 64.4801 30.3498C68.6259 25.8318 69.6209 25.6613 70.533 25.4908ZM149.47 38.9595C151.708 36.0611 155.274 29.4973 155.44 27.7072C155.523 26.8548 155.274 26.5138 154.693 26.599C153.947 26.6842 152.123 28.2187 150.465 30.2645C147.977 33.2481 144.743 39.3005 144.495 41.3463C144.412 42.1988 144.66 42.7102 145.241 42.625C146.153 42.5397 147.728 41.1758 149.47 38.9595ZM163.068 34.271C164.063 32.6514 166.136 33.1628 165.638 34.6972C165.141 35.9759 164.229 38.0218 161.907 40.8349C159.005 44.4151 156.435 46.2053 154.03 46.5463C152.123 46.802 150.796 45.9495 150.465 44.2446L150.382 43.9037C150.382 43.5627 150.216 43.4774 150.05 43.4774C149.884 43.4774 149.718 43.6479 149.387 43.9037C146.982 46.5462 145.158 48.1659 142.919 48.4216C139.603 48.8478 137.613 46.2053 138.11 42.284C137.198 43.6479 136.286 44.9266 135.457 45.8643C132.886 48.8478 130.73 50.7232 128.74 50.9789C126.087 51.3199 124.678 49.3593 125.092 45.9495C125.258 44.4151 125.838 42.5397 126.833 40.2381C127.828 37.9365 129.404 34.6972 130.896 32.1399C132.057 30.0088 133.218 27.6219 133.301 26.7695C133.467 26.0875 133.55 26.0023 133.964 25.6613C134.545 25.2351 135.788 24.7236 136.535 24.6384C138.442 24.4679 140.929 25.9171 139.271 28.8154L138.608 29.9236C138.525 30.1793 137.364 32.2251 136.7 33.4186C135.54 35.3792 133.964 38.1923 132.969 40.1529C132.389 41.3463 132.057 42.1988 131.974 42.8807C131.891 43.3069 132.057 43.5627 132.389 43.4774C132.803 43.3922 133.55 42.966 134.379 42.1135C135.208 41.1758 135.788 40.5791 137.613 38.0218L138.276 37.1694C138.773 36.4021 143.085 30.6907 144.412 29.2416C147.894 24.9794 151.791 21.9958 154.279 21.6548C155.937 21.3991 157.264 22.1663 157.927 23.7859C158.342 25.0646 158.425 25.1499 159.585 25.6613C161.327 26.3433 161.907 27.0252 161.824 27.8777C161.741 28.5596 161.493 29.0711 160.415 30.8612C159.585 32.2251 158.756 33.8448 158.176 35.1235C156.849 37.766 156.103 39.5562 157.43 40.0677C157.927 40.2381 158.756 39.7267 159.917 38.5332C161.244 37.0841 162.073 35.8054 163.068 34.271ZM140.266 20.8876C142.422 20.4614 144.329 18.5008 144.495 16.3697C144.66 14.3238 143.002 12.9599 140.846 13.3861C138.69 13.8123 136.783 15.773 136.618 17.9041C136.535 19.8647 138.11 21.2286 140.266 20.8876ZM107.348 11.0845C102.87 17.1369 97.9784 24.8941 93.6667 32.6514C96.2372 32.0547 98.6417 31.5432 100.963 31.117C102.87 23.8712 105.109 16.5402 107.348 11.0845ZM108.509 29.7531C109.835 29.5826 113.981 29.0711 113.898 30.8612C113.65 33.8448 112.572 33.7596 108.84 34.612C108.094 34.7825 107.348 34.953 106.602 35.1235C106.519 35.2939 106.519 35.4645 106.436 35.4645C105.026 42.284 104.86 44.9266 104.114 50.8085C103.783 53.4511 104.28 56.2641 101.212 56.6903C98.2272 57.1166 97.1492 53.9625 97.1492 51.1495C97.1492 46.2905 99.5538 36.8284 99.5538 36.8284C96.4859 37.5956 93.1692 38.5333 89.9355 39.5562C86.0384 46.3758 78.9076 62.8279 77.9955 66.9197C77.2493 70.2442 75.8397 71.1819 73.6838 70.2442C71.528 69.3065 70.3672 67.0902 71.1134 64.6181C73.1034 57.7985 80.5659 43.1365 80.7317 42.8807C77.9955 43.9889 75.3422 45.2676 73.1034 46.5463C71.6938 47.3135 69.9526 46.5463 69.538 44.8414C69.2892 43.6479 68.7088 41.1758 71.4451 39.9824C75.7568 37.9365 80.483 36.2316 85.2093 34.8677C95.2422 17.5631 107.597 -0.167784 111.245 0.173194C112.82 0.343683 112.572 2.04857 113.898 3.58298C115.225 5.11738 115.474 6.05508 113.815 10.2321C110.499 18.6713 110.83 16.7107 107.597 29.9236C107.845 29.8383 108.177 29.7531 108.509 29.7531ZM113.235 53.7068C115.723 53.4511 122.936 51.8314 123.019 43.6479C123.019 40.4939 120.117 38.789 119.371 36.6579C118.956 35.294 119.039 32.4809 121.112 31.6285C123.683 30.6055 124.18 32.3104 125.092 33.5891C125.424 34.1005 126.668 34.0153 127.082 33.5891C127.663 32.9924 128.492 32.0547 128.823 30.5203C129.155 29.1563 127.663 26.7695 123.517 26.94C122.024 26.94 119.951 27.281 117.049 30.094C115.723 31.3727 111.411 37.5103 114.562 42.7102C115.391 44.1594 117.547 45.8643 116.137 47.2282C114.064 49.2741 110.499 46.12 109.753 45.0971C109.421 44.6709 108.592 44.1594 108.011 45.0118C107.68 45.5233 106.104 48.4216 106.353 49.5298C107.099 53.0248 111.328 53.9625 113.235 53.7068Z"
							fill="white"
						/>
					</svg>
				</div>

				<div class="tara-login__identity">
					<h1 class="tara-login__title" aria-label="T A R A">
						<span class="tara-login__title-grad">T A R A</span>
					</h1>
					<p class="tara-login__subtitle">
						<span class="tara-login__subtitle-init">T</span>raining
						<span class="tara-login__subtitle-init">A</span>ssessment
						<span class="tara-login__subtitle-init">R</span>ecords
						<span class="tara-login__subtitle-init">A</span>nalytics
					</p>
				</div>

				<div class="tara-login__sso">
					<button type="button" class="tara-login__google" (click)="googleSignInClicked()">
						<span class="tara-login__google-pulse tara-login__google-pulse--1" aria-hidden="true"></span>
						<span class="tara-login__google-pulse tara-login__google-pulse--2" aria-hidden="true"></span>
						<span class="tara-login__google-glow" aria-hidden="true"></span>
						<span class="tara-login__google-body">
							<span class="tara-login__google-sweep" aria-hidden="true"></span>
							<span class="tara-login__google-icon-wrap" aria-hidden="true">
								<svg width="16" height="16" viewBox="0 0 24 24">
									<path
										fill="#4285F4"
										d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
									/>
									<path
										fill="#34A853"
										d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
									/>
									<path
										fill="#FBBC05"
										d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
									/>
									<path
										fill="#EA4335"
										d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
									/>
								</svg>
							</span>
							<span class="tara-login__google-label">Continue with Google</span>
							<span class="tara-login__google-ready">
								<span class="tara-login__google-ready-dot" aria-hidden="true"></span>
								Ready
							</span>
						</span>
					</button>
				</div>

				<div class="tara-login__updates">
					@if (updateCheckStatus === "idle") {
						<button type="button" class="tara-login__updates-link" (click)="checkForUpdates()">
							<span class="tara-login__updates-dot" aria-hidden="true"></span>
							<span class="tara-login__updates-label">Check for updates</span>
						</button>
					}
					@if (updateCheckStatus === "checking") {
						<div class="tara-login__updates-pill tara-login__updates-pill--checking">
							<span class="tara-login__updates-spinner" aria-hidden="true"></span>
							<span>Checking system version...</span>
						</div>
					}
					@if (updateCheckStatus === "latest") {
						<div class="tara-login__updates-pill tara-login__updates-pill--latest">
							<span class="tara-login__updates-latest-dot" aria-hidden="true"></span>
							<span>System up to date</span>
						</div>
					}
					<div class="tara-login__version">{{ appVersion }}</div>
				</div>

				@if (googleAuthService.hasError()) {
					<div class="tara-login__error">
						{{ googleAuthService.loginError }}
					</div>
				}
			</div>
		</div>
	</div>
</div>
